import React, { Component } from "react";
import PropType from "prop-types";
import "./SeeMore.css";

function truncateText(text, chars) {
  return text.substr(0, chars) + "...";
}

export default class SeeMore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fullText: props.text,
      showText: truncateText(props.text, props.length),
      showingFull: false,
    };

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();

    if (this.state.showingFull) {
      this.setState({
        showingFull: false,
        showText: truncateText(this.state.fullText, this.props.length),
      });
    } else {
      this.setState({
        showingFull: true,
        showText: this.state.fullText,
      });
    }
  }

  render() {
    return (
      <div className="see-more">
        <div
          className="see-more-content"
          dangerouslySetInnerHTML={{ __html: this.state.showText }}
        />
        <button className="see-more-button" onClick={this.handleClick}>
          {this.state.showingFull ? "See less" : "See more"}
        </button>
      </div>
    );
  }
}

SeeMore.propTypes = {
  text: PropType.string.isRequired,
  length: PropType.string.isRequired,
};
